module.exports = __webpack_public_path__ + "img/clips.5acb7fc9.svg";